/**
 * @module FE-CU57_プライバシーポリシー画面
 */
import TermView from '../../components/termView/TermView.vue';
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';

const PAGE_ID = 'FE-CU57';

export default {
  name: 'PrivacyPolicy',
  components: {
    TermView,
    Header,
    BreadCrumbList,
    PcPageTitle,
    PCFooter,
    MobileFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU57プライバシーポリシー画面.プライバシーポリシー'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU57プライバシーポリシー画面.C0001'),
      htmlContent: '',
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU57プライバシーポリシー画面.プライバシーポリシー'),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU57プライバシーポリシー画面.C0001'
        ),
      };
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.loadHtml(this.$vuetify.lang.current);
  },
  /** @type {Methods} */
  methods: {
    /**
     * 静的ページ読み込み
     * @param {String} lang 言語コード
     */
    loadHtml(lang) {
      var htmlPath = '';
      htmlPath =
        lang === 'ja'
          ? window.location.origin + '/hs-static/privacy-policy-jpn.html'
          : window.location.origin + '/hs-static/privacy-policy-eng.html';

      fetch(htmlPath).then((res) => {
        res.text().then((html) => {
          this.htmlContent = html;
        });
      });
    },
    /**
     * 言語切り替え
     * @param {String} lang 言語コード
     */
    changeLang(lang) {
      this.loadHtml(lang);
    },
  },
};
